import React, {Component} from 'react';
import { Link } from 'react-router';
import Helmet from "react-helmet";

import GuideButton from '../../components/GuideButton';
import GuideHeader from '../../components/GuideHeader';

export default class DeterminingGender extends Component {
  render() {
    const imageUrl = "https://blacksquare.nyc3.digitaloceanspaces.com/janes_colony/guide/guide_header_vegetative_1.jpg";
    return (
      <div>
        <Helmet
          title="Jane's Colony"
          meta={ [
            { name: "description", content: "" },
            { property: "og:title", content: ''},
            { property: "og:url", content: ''},
            { property: "og:image", content: ''},
          ] }
        />
        <GuideHeader imageUrl={imageUrl} />
        <h2>
        Determining Gender
        </h2>
        <p>
        As your plants mature from seedlings into full blown plants, you’ll want to verify their gender. Female plants produce marijuana buds and are the plants we want to keep. Male plants produce pollen that fertilizes female plants, making your buds seedy and ruining the quality of your harvest. 
        </p>
        <p>
        The gender will be revealed when your have several nodes of branches on your plant. Start at the bottom and count up 4 to 6 branches. If you see tiny white hairs, congratulations, you have a female. If you see two little sacks, I’m sorry but you have a male and you should immediately destroy the plant. Placing it in another room will not stop it from pollinating the plant. Never start flowering a plant without determining its gender, although it should be obvious by the time you’re ready for that stage. 
        </p>
        <GuideButton slugTo="pruning" />
      </div>
    )
  }
}





// WEBPACK FOOTER //
// ./src/content/guide/two_determining_gender.js